import { DemoBanner } from './DemoBanner';
import { DemoCapsule } from './DemoCapsule';
import { useDemoInvitation } from './use-demo-invitation';

/**
 * The dashboard's demo invitation: the banner from the third day, the capsule
 * from the second. On the first day the capsule waits for a search in Discovery.
 */
export const DashboardDemoInvitation = () => {
  const { brandId, invitation } = useDemoInvitation();
  if (!brandId || !invitation) return null;
  if (invitation.placement === 'banner') {
    return <DemoBanner brandId={brandId} invitation={invitation} />;
  }
  if (invitation.placement === 'capsule') {
    return <DemoCapsule brandId={brandId} invitation={invitation} />;
  }
  return null;
};
